import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoCorrect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAutoCorrect"><Path fillRule="evenodd" clipRule="evenodd" d="M9.99657 0.504883L4.53012 12.9998H4.49666V13.0762L1.67969 19.5151L3.51201 20.3167L5.83815 14.9998H16.3382L9.99657 0.504883ZM13.2801 12.9998H6.71314L9.99659 5.49467L13.2801 12.9998Z" fill="currentColor"/><Path d="M22.3834 13.7224L20.7193 12.613L16.1746 19.4301L13.9967 17.2522L12.5824 18.6664L16.4854 22.5694L22.3834 13.7224Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoCorrect;
